// Used DatePicker from https://air-datepicker.com/
import AirDatepicker from 'air-datepicker'
import LocaleRu from 'air-datepicker/locale/ru'
import LocaleEn from 'air-datepicker/locale/en'
import LocaleZh from 'air-datepicker/locale/zh'

let localization = {}

Object.defineProperty(localization, '__esModule', {
  value: true,
})
let Locale = (localization.default = void 0)

function localeUrl() {
  let url = window.location.pathname.slice(1, 3)
  switch (url) {
    case 'en':
      Locale = localization.default = LocaleEn
      break
    case 'zh':
      Locale = localization.default = LocaleZh
      break
    default:
      Locale = localization.default = LocaleRu
      break
  }
}
localeUrl()

export let isCalendar

export const calendarRange = new AirDatepicker('.calendar-range', {
  //inline: true,
  autoClose: true,
  locale: Locale,
  position: 'bottom left',
  view: 'days',
  minView: 'days',
  dateFormat: 'dd.MM.yyyy',
  range: true,
  multipleDatesSeparator: ' - ',
  classes: 'datepicker-custom',
  container: document.querySelector('[data-layout-wrapper-inner]'),
  onSelect: ({ datepicker }) => {
    datepicker.$el.dispatchEvent(new Event('input'))
  },
  onShow: (isFinished) => {
    isCalendar = isFinished
  },
})

export const calendarSingle = new AirDatepicker('.calendar-single', {
  autoClose: true,
  locale: Locale,
  position: 'bottom left',
  view: 'days',
  minView: 'days',
  dateFormat: 'dd.MM.yyyy',
  range: false,
  multipleDatesSeparator: ' - ',
  classes: 'datepicker-custom',
  container: document.querySelector('[data-layout-wrapper-inner]'),
  onSelect: ({ datepicker }) => {
    datepicker.$el.dispatchEvent(new Event('input'))
  },
})
